
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[account-name]/maps/[map-id]",
      function () {
        return require("private-next-pages/[account-name]/maps/[map-id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[account-name]/maps/[map-id]"])
      });
    }
  